import { ColumnConfig } from '../components/Portfolio/PortfolioSection'

// Position filtering configuration
export const HIDE_USD_BALANCE_THRESHOLD = 0 // Hide positions with less than $1 USD value

// Column configurations
export const V3_COLUMNS: ColumnConfig[] = [
  { key: 'pool', label: 'Pool', className: '' },
  { key: 'range', label: 'Range', className: '' },
  { key: 'balances', label: 'Token Balances', className: '' },
  { key: 'value', label: 'Total Value', className: '' },
  { key: 'fees', label: 'Unclaimed Fees', className: '' },
  { key: 'actions', label: 'Actions', className: 'text-center' },
]

export const V2_COLUMNS: ColumnConfig[] = [
  { key: 'pair', label: 'Pool', className: '' },
  { key: 'balances', label: 'Token Balances', className: '' },
  { key: 'value', label: 'Total Value', className: '' },
  { key: 'share', label: 'Pool Share', className: '' },
  { key: 'actions', label: 'Actions', className: 'text-right' },
]

export const FARM_COLUMNS: ColumnConfig[] = [
  { key: 'token', label: 'Token', className: '' },
  { key: 'balances', label: 'Token Balances', className: 'text-right' },
  { key: 'apr', label: 'APR', className: 'text-right' },
  { key: 'value', label: 'Total Value', className: 'text-right' },
  { key: 'rewards', label: 'Unclaimed Rewards', className: 'text-right' },
  { key: 'actions', label: 'Actions', className: 'text-right' },
]

export const TOP_POOLS_COLUMNS: ColumnConfig[] = [
  { key: 'pool', label: 'Pool', className: '' },
  { key: 'range', label: 'Range', className: '' },
  { key: 'balances', label: 'Token Balances', className: 'text-right' },
  { key: 'apr', label: 'APR', className: 'text-right' },
  { key: 'value', label: 'Total Value', className: 'text-right' },
  { key: 'rewards', label: 'Unclaimed Rewards', className: 'text-right' },
  { key: 'actions', label: 'Actions', className: 'text-right' },
]

export const TOKEN_HOLDINGS_DESKTOP_COLUMNS: ColumnConfig[] = [
  { key: 'token', label: 'Token', className: '' },
  { key: 'price', label: 'Price', className: '' },
  { key: 'amount', label: 'Amount', className: '' },
  { key: 'value', label: 'USD Value', className: 'text-right' },
]

export const TOKEN_HOLDINGS_MOBILE_COLUMNS: ColumnConfig[] = [
  { key: 'token-amount', label: 'Token/Amount', className: '' },
  { key: 'price', label: 'Price', className: '' },
  { key: 'value', label: 'USD Value', className: 'text-right' },
]

export const KDK_STAKING_COLUMNS: ColumnConfig[] = [
  { key: 'token', label: 'Token', className: '' },
  { key: 'balance', label: 'Token Balances', className: 'text-right' },
  { key: 'apr', label: 'APR', className: 'text-right' },
  { key: 'value', label: 'Total Value', className: 'text-right' },
  { key: 'rewards', label: 'Protocol Rewards', className: 'text-right' },
  { key: 'actions', label: 'Actions', className: 'text-right' },
]

// Position type badges
export const POSITION_BADGES = {
  v3: {
    label: 'V3',
    textColor: '#6BBCEF',
    bgColor: '#295BA433',
  },
  v2: {
    label: 'V2',
    textColor: '#A9BBD0',
    // bgColor: '#46608133',
    bgColor: '#46608133',
  },
  island: {
    label: 'Island',
    textColor: '#69B1F0',
    bgColor: '#3083DC33',
  },
  charm: {
    label: 'Charm',
    textColor: '#A78BFA',
    bgColor: '#A78BFA33',
  },
  bault: {
    label: 'Bault',
    textColor: '#6EE7B7',
    bgColor: '#05966933',
  },
  farm: {
    label: 'Reward Vault',
    textColor: '#FCCB5A',
    bgColor: '#FFB82B33',
  },
  kodiakFarm: {
    label: 'Kodiak Farm',
    textColor: '#9BD4F5',
    bgColor: '#2B6FCA33',
  },
  inRange: {
    label: 'In Range',
    textColor: '#6EE7B7',
    bgColor: '#05966933',
    dotColor: '#34D399',
  },
  outOfRange: {
    label: 'Out of Range',
    textColor: '#FCCB5A',
    bgColor: '#FFB82B33',
    dotColor: '#FCCB5A',
  },
} as const

export const PORTFOLIO_FILTER_CONFIG = [
  { id: 'tokens', label: 'Tokens', section: 'tokens' },
  { id: 'top-pools', label: 'Top Pools', section: 'top-pools' },
  { id: 'v3-positions', label: 'V3 Positions', section: 'v3' },
  { id: 'v2-positions', label: 'V2 Positions', section: 'v2' },
  { id: 'farms', label: 'Farms', section: 'farms' },
  { id: 'staking', label: 'Staking', section: 'staking' },
] as const

export type PortfolioFilterId = (typeof PORTFOLIO_FILTER_CONFIG)[number]['id']
